module.exports = __webpack_public_path__ + "static/media/banner-3.c2189f89.webp";